import type { PropsWithChildren } from "react";

import { getLocalStorageKey, LocalStorageKey } from "@/storage/local-storage";

import { GalaxyTheme } from "@gx/dls/theme/constants";
import { GalaxyThemeProvider } from "@gx/dls/theme/GalaxyTheme";

import useLocalStorage from "@/hooks/useLocalStorage";

const ThemeProvider = ({ children }: PropsWithChildren) => {
  const storageKey = getLocalStorageKey(LocalStorageKey.THEME);
  const [storedTheme, setStoredTheme] = useLocalStorage(
    LocalStorageKey.THEME,
    GalaxyTheme.SYSTEM,
    GalaxyTheme,
  );

  return (
    <GalaxyThemeProvider
      initialTheme={storedTheme}
      storageKey={storageKey}
      storage={{
        get: () => storedTheme,
        set: (_, theme) => setStoredTheme(theme),
      }}
    >
      {children}
    </GalaxyThemeProvider>
  );
};

export default ThemeProvider;
